import React, { useEffect } from "react";
import { Redirect } from "react-router";
import logo from "assets/images/auth-logo.png";

import styles from "assets/scss/layouts/authLayout.module.scss";

export const AuthLayout = ({ children }) => {
  if (localStorage.getItem("token") != null) {
    return <Redirect to="/admin/dashboard" />;
  }

  return (
    <div className={styles.auth_layout}>
      <div className="row">
        <div className="col-md-4 p-0">
          <div className={styles.auth_left}>
            <img src={logo} />
            <div className={styles.quotes}>
              <b>CREATIVITY</b>
              <span>is making</span>
              <b>MARVELOUS</b>
              <span>out of the</span>
              <b>DISCARDED</b>
            </div>
          </div>
        </div>
        <div className="col-md-8 p-0">
          <div className={styles.auth_right}>{children}</div>
        </div>
      </div>
      <div className={styles.circle_1}></div>
      <div className={styles.circle_2}></div>
    </div>
  );
};
